import {
  AttachmentRequestRecord,
  ClusterCandidateRecord,
  ClusterDetachRecord,
  ConnectionRecord,
  ContentNotificationRecord,
  NetworkTuple,
  NodeStateRecord,
  PeerConnection,
  PeerNotificationRecord,
  PeerRequestRecord
} from './interfaces';
import { NodeState, PeeringProtocol, TransportType } from './data';

export class ConnectionRecordImpl implements ConnectionRecord {
  nodeId: string;
  agentId: string;
  contentId: string;
  tenantId: string;
  clusterId: string;
  locality: string;
  connection: PeerConnection;
  timestamp: number;
  monotonicTime: number;

  constructor(
    nodeId: string,
    agentId: string,
    contentId: string,
    tenantId: string,
    clusterId: string,
    locality: string,
    timestamp: number,
    monotonicTime: number,
    connection: PeerConnection
  ) {
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.contentId = contentId;
    this.tenantId = tenantId;
    this.clusterId = clusterId;
    this.locality = locality;
    this.timestamp = timestamp;
    this.monotonicTime = monotonicTime;
    this.monotonicTime = monotonicTime;
    this.connection = connection;
  }
}

export class ContentNotificationRecordImpl
  implements ContentNotificationRecord {
  nodeId: string;
  agentId: string;
  contentId: string;
  tenantId: string;
  clusterId: string;
  locality: string;
  timestamp: number;
  monotonicTime: number;
  peerId: string;
  objectId: string;
  status: string;

  constructor(
    nodeId: string,
    agentId: string,
    contentId: string,
    tenantId: string,
    clusterId: string,
    locality: string,
    timestamp: number,
    monotonicTime: number,
    peerId: string,
    objectId: string,
    status: string
  ) {
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.contentId = contentId;
    this.tenantId = tenantId;
    this.clusterId = clusterId;
    this.locality = locality;
    this.timestamp = timestamp;
    this.monotonicTime = monotonicTime;
    this.peerId = peerId;
    this.objectId = objectId;
    this.status = status;
  }
}

export class NetworkTupleImpl implements NetworkTuple {
  nodeId: string;
  extIp: string | undefined;
  intIp: string | undefined;
  port: number | undefined;
  depth: number;
  capacity: number;
  intMdns: string | undefined;
  constructor(
    nodeId: string,
    extIp: string | undefined,
    intIp: string | undefined,
    port: number,
    depth: number,
    capacity: number,
    intMdns: string | undefined
  ) {
    this.nodeId = nodeId;
    this.extIp = extIp;
    this.intIp = intIp;
    this.port = port;
    this.depth = depth;
    this.capacity = capacity;
    this.intMdns = intMdns;
  }
}

export class PeeringProtocolImpl implements PeeringProtocol {
  type: TransportType;
  majorVersion: number;
  minorVersion: number;
  uris: string[];
  constructor(
    type: TransportType,
    majorVersion: number,
    minorVersion: number,
    uris: string[]
  ) {
    this.type = type;
    this.majorVersion = majorVersion;
    this.minorVersion = minorVersion;
    this.uris = uris;
  }
}

export class PeerConnectionImpl implements PeerConnection {
  type: string;
  state: string;
  source: NetworkTuple;
  dest: NetworkTuple;
  protocol: PeeringProtocol;
  statusCode: number;

  constructor(
    type: string,
    state: string,
    source: NetworkTuple,
    dest: NetworkTuple,
    protocol: PeeringProtocol,
    statusCode: number
  ) {
    this.type = type;
    this.state = state;
    this.source = source;
    this.dest = dest;
    this.protocol = protocol;
    this.statusCode = statusCode;
  }
}

export class PeerRequestRecordImpl implements PeerRequestRecord {
  nodeId: string;
  agentId: string;
  contentId: string;
  tenantId: string;
  clusterId: string;
  locality: string;
  peerId: string;
  originId: string;
  timestamp: number;
  requestTime: number;
  responeTime: number;
  candidates: string[] | undefined;
  path: string[] | undefined;
  statusCode: number;

  constructor(
    nodeId: string,
    agentId: string,
    contentId: string,
    tenantId: string,
    clusterId: string,
    locality: string,
    peerId: string,
    originId: string,
    timestamp: number,
    requestTime: number,
    responeTime: number,
    candidates: string[] | undefined,
    path: string[] | undefined,
    statusCode: number
  ) {
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.contentId = contentId;
    this.tenantId = tenantId;
    this.clusterId = clusterId;
    this.locality = locality;
    this.peerId = peerId;
    this.originId = originId;
    this.timestamp = timestamp;
    this.requestTime = requestTime;
    this.responeTime = responeTime;
    this.candidates = candidates;
    this.path = path;
    this.statusCode = statusCode;
  }
}

export class NodeStateRecordImpl implements NodeStateRecord {
  nodeId: string;
  agentId: string;
  contentId: string;
  tenantId: string;
  clusterId: string;
  locality: string;
  timestamp: number;
  monotonicTime: number;
  reporterId: string | undefined;
  depth: number | undefined;
  state: NodeState;

  constructor(
    nodeId: string,
    agentId: string,
    contentId: string,
    tenantId: string,
    clusterId: string,
    locality: string,
    timestamp: number,
    monotonicTime: number,
    reporterId: string | undefined,
    depth: number | undefined,
    state: NodeState
  ) {
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.contentId = contentId;
    this.tenantId = tenantId;
    this.clusterId = clusterId;
    this.locality = locality;
    this.timestamp = timestamp;
    this.monotonicTime = monotonicTime;
    this.reporterId = reporterId;
    this.depth = depth;
    this.state = state;
  }
}

export class PeerNotificationRecordImpl implements PeerNotificationRecord {
  nodeId: string;
  agentId: string;
  contentId: string;
  tenantId: string;
  clusterId: string;
  locality: string;
  timestamp: number;
  monotonicTime: number;
  peerId: string;
  reportedPeer: string;
  state: NodeState;

  constructor(
    nodeId: string,
    agentId: string,
    contentId: string,
    tenantId: string,
    clusterId: string,
    locality: string,
    timestamp: number,
    monotonicTime: number,
    peerId: string,
    reportedPeer: string,
    state: NodeState
  ) {
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.contentId = contentId;
    this.tenantId = tenantId;
    this.clusterId = clusterId;
    this.locality = locality;
    this.timestamp = timestamp;
    this.monotonicTime = monotonicTime;
    this.peerId = peerId;
    this.reportedPeer = reportedPeer;
    this.state = state;
  }
}

export class ClusterDetachRecordImpl implements ClusterDetachRecord {
  nodeId: string;
  agentId: string;
  contentId: string;
  tenantId: string;
  clusterId: string;
  locality: string;
  timestamp: number;
  monotonicTime: number;
  reportingPeer: string;
  detachingPeer: string;

  constructor(
    nodeId: string,
    agentId: string,
    contentId: string,
    tenantId: string,
    clusterId: string,
    locality: string,
    timestamp: number,
    monotonicTime: number,
    reportingPeer: string,
    detachingPeer: string
  ) {
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.contentId = contentId;
    this.tenantId = tenantId;
    this.clusterId = clusterId;
    this.locality = locality;
    this.timestamp = timestamp;
    this.monotonicTime = monotonicTime;
    this.reportingPeer = reportingPeer;
    this.detachingPeer = detachingPeer;
  }
}

export class ClusterCandidateRecordImpl implements ClusterCandidateRecord {
  clusterId: string;
  candidates: string[];

  constructor(clusterId: string, candidates: string[]) {
    this.clusterId = clusterId;
    this.candidates = candidates;
  }
}

export class AttachmentRequestRecordImpl implements AttachmentRequestRecord {
  nodeId: string;
  agentId: string;
  contentId: string;
  tenantId: string;
  clusterId: string | undefined;
  locality: string;
  timestamp: number;
  requestTime: number;
  responseTime: number;
  clusterCandidates: ClusterCandidateRecord[] | undefined;
  backupCluster: string | undefined;
  statusCode: number;

  constructor(
    nodeId: string,
    agentId: string,
    contentId: string,
    tenantId: string,
    clusterId: string | undefined,
    locality: string,
    timestamp: number,
    requestTime: number,
    responseTime: number,
    clusterCandidates: ClusterCandidateRecord[] | undefined,
    backupCluster: string | undefined,
    statusCode: number
  ) {
    this.nodeId = nodeId;
    this.agentId = agentId;
    this.contentId = contentId;
    this.tenantId = tenantId;
    this.clusterId = clusterId;
    this.locality = locality;
    this.timestamp = timestamp;
    this.requestTime = requestTime;
    this.responseTime = responseTime;
    this.clusterCandidates = clusterCandidates;
    this.backupCluster = backupCluster;
    this.statusCode = statusCode;
  }
}
